import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-square",
  "use": "icon-si-glyph-square-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-square\" id=\"icon-si-glyph-square\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1230</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0.00199999998,1 C0.00199999998,0.447 0.446,0 0.995,0 L14.967,0 C15.516,0 15.96,0.447 15.96,1 L15.96,15 C15.96,15.553 15.516,16 14.967,16 L0.995,16 C0.446,16 0.00199999998,15.553 0.00199999998,15 L0.00199999998,1 L0.00199999998,1 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-square.svg
// module id = 4Pg0
// module chunks = 62